/* unplugin-vue-components disabled */import { render } from "./TopNav.vue?vue&type=template&id=2b9a2a82&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=2b9a2a82&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a2a82"]])

export default __exports__